var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Slider } from 'antd';
import { connect } from '@formily/react-schema-renderer';
import { mapStyledProps } from '../shared';
export var Range = connect({
    defaultProps: {
        style: {
            width: 320
        }
    },
    getProps: mapStyledProps
})((function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, value = _a.value, min = _a.min, max = _a.max, marks = _a.marks, rest = __rest(_a, ["onChange", "value", "min", "max", "marks"]);
        var newMarks = {};
        if (Array.isArray(marks)) {
            marks.forEach(function (mark) {
                newMarks[mark] = mark;
            });
        }
        else {
            newMarks = marks;
        }
        return (React.createElement(Slider, __assign({}, rest, { onChange: onChange, value: value, min: min, max: max, marks: newMarks })));
    };
    return Component;
}(React.Component)));
export default Range;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/range/index.js
// module id = 1055
// module chunks = 0